/**
 * LeaderboardScene — in-canvas full-screen leaderboard.
 *
 * Press L on the GameOver screen to enter. Renders the top 20 scores from
 * Supabase in a monospace, monochrome white-on-black table. Press ESC or
 * click BACK to return to the game-over screen.
 */
import Phaser from "phaser";
import { GAME_HEIGHT, GAME_WIDTH } from "../Game";
import { fetchTopScores, type ScoreRow } from "../../lib/api";

export class LeaderboardScene extends Phaser.Scene {
  constructor() {
    super({ key: "LeaderboardScene" });
  }

  public create(): void {
    this.cameras.main.setBackgroundColor("#000000");

    const cx = GAME_WIDTH / 2;
    this.add.text(cx, 25, "TRASHBOARD", {
      fontFamily: '"Press Start 2P", monospace',
      fontSize: "28px",
      color: "#ffffff",
      stroke: "#000000",
      strokeThickness: 3,
    }).setOrigin(0.5);

    this.add.text(cx, 55, "🏆 CONTEST FINISHED — TOP 3 WINNERS 🏆", {
      fontFamily: '"Press Start 2P", monospace',
      fontSize: "11px",
      color: "#ff3333",
      stroke: "#000000",
      strokeThickness: 2,
    }).setOrigin(0.5);

    const list = this.add.text(cx, 85, "LOADING…", {
      fontFamily: '"Press Start 2P", monospace',
      fontSize: "14px",
      color: "#ffffff",
      align: "center",
    }).setOrigin(0.5, 0);

    void this.loadRows(list);

    this.add.text(cx, GAME_HEIGHT - 25, "PRESS [ESC] TO GO BACK", {
      fontFamily: '"Press Start 2P", monospace',
      fontSize: "12px",
      color: "#ffffff",
    }).setOrigin(0.5);

    this.input.keyboard?.addKey("ESC").once("down", () => this.scene.start("GameOverScene"));
  }

  private async loadRows(text: Phaser.GameObjects.Text): Promise<void> {
    try {
      const rows: ScoreRow[] = await fetchTopScores(20);
      if (rows.length === 0) {
        text.setText("NO SCORES YET.");
        return;
      }
      const formatted = rows
        .map((r, i) => {
          const rankStr = i === 0 ? "🥇01." : i === 1 ? "🥈02." : i === 2 ? "🥉03." : `${(i + 1).toString().padStart(2, "0")}. `;
          return `${rankStr.padEnd(5, " ")} ${r.display_name.padEnd(12, " ")}  ${r.score.toString().padStart(6, " ")}`;
        })
        .join("\n");
      text.setText(formatted);
    } catch (err) {
      text.setText(`ERROR: ${(err as Error).message}`);
    }
  }
}